import React from 'react';
import { LLVoteWidgetBody, LLVoteWidgetBodyProps } from '../LLVoteWidgetBody';
import { LLWidgetVoteOption, LLWidgetVoteOptionProps } from '../LLWidgetOption';

export function LLPredictionFollowUpWidgetBody(props: LLVoteWidgetBodyProps) {
  return (
    <LLVoteWidgetBody
      {...props}
      VoteOptionComponent={LLPredictionFollowUpWidgetOption}
    />
  );
}

export function LLPredictionFollowUpWidgetOption(
  props: LLWidgetVoteOptionProps
) {
  return <LLWidgetVoteOption {...props} correctable={true} />;
}
